/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_21f186f6"]'><cube-button-group :class='["btn-wrapper"]'><cube-button :class='["btn-item"]'>取消按钮</cube-button><cube-button primary :class='["btn-item"]'>确认按钮</cube-button></cube-button-group></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_21f186f6"}'>
.btn-item
  margin-bottom 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_21f186f6"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_21f186f6"}
  /** script content **/
  require("./button-group-vertical-two.mpx.js?isComponent&outputPath=components%2Fbutton-group-vertical-two21f186f6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./button-group-vertical-two.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbutton-group-vertical-two21f186f6%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_21f186f6"],
    ctorType: "component",
    outputPath: "components/button-group-vertical-two21f186f6/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-button-group':getComponent(require("../../../packages/mpx-cube-ui/src/components/button-group/index.mpx?isComponent&outputPath=components%2Findexb32f512a%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>